import React, {Component} from 'react';
import {Col, Row, Select} from "antd";
import countries from "../../../assets/data/country.json";
import Utils from "../../../utils";
import CountryFlag from "../display/CountryFlag";

interface IProps {
    value?: string | string[]
    onChange?: (key?: string|string[]) => void
    className?: string
    placeholder?: string
    disabled?: boolean
    allowClear?: boolean
    multiple?: boolean
}

class CountryPicker extends Component<IProps> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            value: props.value
        }
    }

    static defaultProps = {
        output: 'hex',
        allowClear: true
    }

    onChange = (value: string | string[]) => {
        const {onChange} = this.props
        onChange && onChange(value)
    }

    render() {
        const {value, disabled, placeholder, allowClear, multiple} = this.props

        return (
            <Select style={{minWidth: 200}} value={value} placeholder={placeholder} allowClear={allowClear} disabled={disabled}
                    showSearch={true} mode={multiple ? 'multiple' : undefined}
                    filterOption={(input, option) =>
                        Utils.stringContains(option?.value, input) || Utils.stringContains(option?.title, input)
                    }
                    onChange={this.onChange}>
                {countries.map(country => (
                    <Select.Option value={country.code} title={country.name}>
                        <Row gutter={6} justify={"space-between"}>
                            <Col>{country.name} {'[' + country.code + ']'}</Col>
                            <Col className={'d-flex align-items-center'}><CountryFlag countryCode={country.code}/></Col>
                        </Row>
                    </Select.Option>
                ))}
            </Select>
        )
    }
}

export default CountryPicker
